module.exports = function (timeMs) {
  return function (target, key, descriptor) {
    const oldValue = descriptor.value;

    descriptor.value = function (...args) {
      clearTimeout(target.timeoutClearTarget);

      target.timeoutClearTarget = setTimeout(() => oldValue.apply(this, args), timeMs);
    };

    return descriptor;
  };
};



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/timeout.js